
                            const chunks = `/// #replace #define SIXTY_UNIFORMS_AREA
#define SIXTY_UNIFORMS_AREA

uniform sampler2D tNoise;
uniform float uTime;
varying vec3 vPosition;


/// #replace vec4 diffuseColor = vec4(uColor, uOpacity);
vec4 diffuseColor = vec4(uColor, uOpacity);

vec2 dUv = vUv;
// Slight eye movements

dUv.y += 0.01 * (sin(uTime) / abs(sin(uTime))) * (vPosition.x / abs(vPosition.x));

vec2 center = vec2(0.52, 0.55);
float iris = smoothstep(0.17, 0.12, length(dUv - center)); 

float pupilSize = 1. - 0.2 * smoothstep(0.6, 0.8, (sin(uTime) * sin(uTime * 0.7)));
float pupil = smoothstep(0.05 * pupilSize, 0.08 * pupilSize, length(dUv - vec2(0.52, 0.55))); 

diffuseColor.rgb = vec3(0.9);

vec3 sclera = vec3(0.6, 0.5, 0.4);
float red = smoothstep(0.3, .2, length(dUv - vec2(0.52, 0.57)));
sclera.gb *= 0.2 + 0.8 * red;


vec3 eyeColor = vec3(0.37, 0.09, 0.05) * 0.05;

eyeColor = mix(eyeColor, vec3(0.6, 0.05, 0.), step(0., -vPosition.x) * smoothstep(0.9, 0.93, fract(length(dUv - center) - uTime * 0.2)));

eyeColor *= 1. + 1. *  smoothstep(0.12, 0.05, length(dUv - center));

diffuseColor.rgb = mix(sclera, eyeColor, iris);
diffuseColor.rgb *= pupil;


/// #replace vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;

float shade = 1. - smoothstep(0.38, 0.6, dUv.x);
vec3 shadow = vec3(shade);
shadow.r *= 1.5;

vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
outgoingLight *= shadow;
`;

                            function replace(chunksCode = '', defaultShader = '') {
                                const chunks = parseCode(chunksCode);
                                chunks.forEach(({ target, replace }) => {
                                    defaultShader = defaultShader.replace(target, replace);
                                });

                                return defaultShader;
                            }

                            function parseCode(code, pattern = '/// #replace') {
                                const replacements = [];
                                const lines = code.trim().split('\n');

                                for (let i = 0; i < lines.length; i++) {
                                    const line = lines[i].trim();
                                    if (line.startsWith(pattern)) {
                                        const target = line.replace(pattern, '');
                                        const replaceLines = [];
                                        let j = i + 1;

                                        while (j < lines.length && !lines[j].trim().startsWith(pattern)) {
                                            const nextLine = lines[j].trim();
                                            if (nextLine) {
                                                replaceLines.push(nextLine);
                                            }
                                            j++;
                                        }

                                        const replace = replaceLines.join('\n');
                                        replacements.push({ target: target.trim(), replace: replace.trim() });

                                        i = j - 1;
                                    }
                                }
                                return replacements;
                            }

                            export default {
                                use: (el) => {
                                    const instance = el.material || el;
                                    instance['fragmentShader'] = replace(chunks, instance['fragmentShader']);
                                    instance.needsUpdate = true;
                                    return el;
                                }
                            }
                        